import {
  PHARMACY_TYPES,
  ORDER_TYPES,
  DEFAULT_PHARMACY_LIST_LIMIT,
  LIMIT_OPTIONS,
  TABS
} from './constants';

export const getPharmacyType = pharmacyType => {
  return Object.values(PHARMACY_TYPES).includes(pharmacyType) ? pharmacyType : PHARMACY_TYPES.OTC;
};

export const getOrderType = orderType => {
  return Object.values(ORDER_TYPES).includes(orderType) ? orderType : '';
};

export const getLimit = limit => {
  return Object.values(LIMIT_OPTIONS).includes(limit) ? limit : DEFAULT_PHARMACY_LIST_LIMIT;
};

export const getTab = tab => {
  return Object.values(TABS).includes(tab) ? tab : TABS.ALL;
};
